exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".banner_img[data-v-68e38687]{width:195px;height:45px;line-height:45px}\n", ""]);

// exports
